export default __webpack_public_path__ + "static/media/img2.fbcc9210.png";